import type { PartnerStatus, RelationshipStatus } from '../types';
import { RELATIONSHIP_STATUS_LABELS } from '../types';

type Tone = 'ok' | 'wait' | 'bad' | 'neutral';

const RELATIONSHIP_TONE: Record<RelationshipStatus, Tone> = {
  Prospect: 'neutral',
  InvitationSent: 'wait',
  AwaitingClientAcceptance: 'wait',
  Onboarding: 'wait',
  Active: 'ok',
  Suspended: 'bad',
  Revoked: 'bad',
  Ended: 'neutral',
};

const ICON: Record<Tone, string> = { ok: '✔', wait: '◔', bad: '⛔', neutral: '○' };

/** A status shown with an icon AND its words, never by colour alone. */
export function StatusBadge({ tone, children }: { tone: Tone; children: string }) {
  return (
    <span className={`pp-badge pp-badge--${tone}`}>
      <span aria-hidden="true">{ICON[tone]}</span> {children}
    </span>
  );
}

export function RelationshipBadge({ status }: { status: RelationshipStatus }) {
  return <StatusBadge tone={RELATIONSHIP_TONE[status]}>{RELATIONSHIP_STATUS_LABELS[status]}</StatusBadge>;
}

const FIRM_LABELS: Record<PartnerStatus, string> = {
  ApplicationDraft: 'Application draft',
  Submitted: 'Submitted',
  UnderReview: 'Under review',
  InformationRequired: 'Information required',
  Approved: 'Approved',
  Active: 'Active',
  Suspended: 'Suspended',
  Terminated: 'Terminated',
  Rejected: 'Rejected',
};

export function FirmStatusBadge({ status }: { status: PartnerStatus }) {
  const tone: Tone = status === 'Active' ? 'ok' : status === 'Suspended' || status === 'Terminated' || status === 'Rejected' ? 'bad' : 'wait';
  return <StatusBadge tone={tone}>{FIRM_LABELS[status]}</StatusBadge>;
}
